import { createRoot } from "react-dom/client";

import "@/styles/index.less";
import App from "./App";

createRoot(document.getElementById("root")!).render(<App />);
